"use strict";

var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/workspace/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/workspace/node_modules/@babel/runtime/helpers/createClass");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.evaluate = evaluate, exports.Evaluator = void 0;

var _ethers = require("ethers"),
    _types = _interopRequireDefault(require("../types")),
    _HelperManager = _interopRequireDefault(require("../helpers/HelperManager")),
    _defaults = require("../defaults");
/**
* @module radspec/evaluator
*/

/**
* A value coupled with a type
*
* @class TypedValue
* @param {string} type The type of the value
* @param {*} value The value
* @property {string} type
* @property {*} value
*/


var TypedValue =
/*#__PURE__*/
function () {
  function TypedValue(type, value) {
    _classCallCheck(this, TypedValue);

    if (this.type = type, this.value = value, _types.default.isInteger(this.type) && !_ethers.BigNumber.isBigNumber(this.value) && (this.value = _ethers.BigNumber.from(this.value)), "address" === this.type) {
      if (!_ethers.ethers.utils.isAddress(this.value)) throw new Error("Invalid address \"".concat(this.value, "\""));
      this.value = _ethers.ethers.utils.getAddress(this.value);
    }
  }
  /**
  * Get the string representation of the wrapped value
  *
  * @return {string}
  */


  _createClass(TypedValue, [{
    key: "toString",
    value: function toString() {
      return this.value.toString();
    }
  }]);

  return TypedValue;
}();
/**
* Walks an AST and evaluates each node.
*
* @class Evaluator
* @param {radspec/parser/AST} ast The AST to evaluate
* @param {radspec/Bindings} bindings An object of bindings and their values
* @param {?Object} options An options object
* @param {?Object} options.availablehelpers Available helpers
* @param {?ethers.providers.Provider} options.provider EIP 1193 provider
* @param {?string} options.to The destination address for this expression's transaction
* @property {radspec/parser/AST} ast
* @property {radspec/Bindings} bindings
*/


var Evaluator =
/*#__PURE__*/
function () {
  function Evaluator(ast, bindings) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$availableHelpers = _ref.availableHelpers,
        availableHelpers = _ref$availableHelpers === void 0 ? {} : _ref$availableHelpers,
        provider = _ref.provider,
        from = _ref.from,
        to = _ref.to,
        _ref$value = _ref.value,
        value = _ref$value === void 0 ? "0" : _ref$value,
        data = _ref.data;

    _classCallCheck(this, Evaluator);

    this.ast = ast, this.bindings = bindings, this.provider = provider || new _ethers.ethers.providers.WebSocketProvider(_defaults.DEFAULT_ETH_NODE), this.from = from && new TypedValue("address", from), this.to = to && new TypedValue("address", to), this.value = new TypedValue("uint", _ethers.BigNumber.from(value)), this.data = data && new TypedValue("bytes", data), this.helpers = new _HelperManager.default(availableHelpers);
  }
  /**
  * Evaluate an array of AST nodes.
  *
  * @param  {Array<radspec/parser/Node>} nodes
  * @return {Promise<Array<string>>}
  */


  _createClass(Evaluator, [{
    key: "evaluateNodes",
    value: function () {
      var _evaluateNodes = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(nodes) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", Promise.all(nodes.map(this.evaluateNode.bind(this))));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function evaluateNodes(_x) {
        return _evaluateNodes.apply(this, arguments);
      }

      return evaluateNodes;
    }()
    /**
    * Evaluate a single node.
    *
    * @param  {radspec/parser/Node} node
    * @return {Promise<string>}
    */

  }, {
    key: "evaluateNode",
    value: function () {
      var _evaluateNode = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(node) {
        var _Mathceil, length, left, right, _left, _right, leftValue, rightValue, bothTypesAddress, bothTypesBytes, _left2, leftFalsey, target, inputs, outputs, selectedReturnValueIndex, returnType, abi, ethersInterface, txData, data, decodeData, helperName, _inputs, result, binding;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _Mathceil = Math.ceil;

                if (!("ExpressionStatement" === node.type)) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 4;
                return this.evaluateNodes(node.body);

              case 4:
                return _context2.abrupt("return", _context2.sent.join(" "));

              case 5:
                if (!("GroupedExpression" === node.type)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", this.evaluateNode(node.body));

              case 7:
                if (!("MonologueStatement" === node.type)) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return", new TypedValue("string", node.value));

              case 9:
                if (!("StringLiteral" === node.type)) {
                  _context2.next = 11;
                  break;
                }

                return _context2.abrupt("return", new TypedValue("string", node.value || ""));

              case 11:
                if (!("NumberLiteral" === node.type)) {
                  _context2.next = 13;
                  break;
                }

                return _context2.abrupt("return", new TypedValue("int256", node.value));

              case 13:
                if (!("BytesLiteral" === node.type)) {
                  _context2.next = 16;
                  break;
                }

                length = _Mathceil((node.value.length - 2) / 2);
                return _context2.abrupt("return", (32 < length && this.panic("Byte literal represents more than 32 bytes"), new TypedValue("bytes".concat(length), node.value)));

              case 16:
                if (!("BoolLiteral" === node.type)) {
                  _context2.next = 18;
                  break;
                }

                return _context2.abrupt("return", new TypedValue("bool", "true" === node.value));

              case 18:
                if (!("BinaryExpression" === node.type)) {
                  _context2.next = 37;
                  break;
                }

                _context2.next = 21;
                return this.evaluateNode(node.left);

              case 21:
                left = _context2.sent;
                _context2.next = 24;
                return this.evaluateNode(node.right);

              case 24:
                right = _context2.sent;

                if (!(("string" === left.type || "string" === right.type) && "PLUS" === node.operator)) {
                  _context2.next = 27;
                  break;
                }

                return _context2.abrupt("return", new TypedValue("string", left.value.toString() + right.value.toString()));

              case 27:
                _context2.t0 = (_types.default.isInteger(left.type) && _types.default.isInteger(right.type) || this.panic("Cannot evaluate binary expression \"".concat(node.operator, "\" for non-integer types \"").concat(left.type, "\" and \"").concat(right.type, "\"")), node.operator);
                _context2.next = _context2.t0 === "PLUS" ? 30 : _context2.t0 === "MINUS" ? 31 : _context2.t0 === "STAR" ? 32 : _context2.t0 === "POWER" ? 33 : _context2.t0 === "SLASH" ? 34 : _context2.t0 === "MODULO" ? 35 : 36;
                break;

              case 30:
                return _context2.abrupt("return", new TypedValue("int256", left.value.add(right.value)));

              case 31:
                return _context2.abrupt("return", new TypedValue("int256", left.value.sub(right.value)));

              case 32:
                return _context2.abrupt("return", new TypedValue("int256", left.value.mul(right.value)));

              case 33:
                return _context2.abrupt("return", new TypedValue("int256", left.value.pow(right.value)));

              case 34:
                return _context2.abrupt("return", new TypedValue("int256", left.value.div(right.value)));

              case 35:
                return _context2.abrupt("return", new TypedValue("int256", left.value.mod(right.value)));

              case 36:
                this.panic("Undefined binary operator \"".concat(node.operator, "\""));

              case 37:
                if (!("ComparisonExpression" === node.type)) {
                  _context2.next = 55;
                  break;
                }

                _context2.next = 40;
                return this.evaluateNode(node.left);

              case 40:
                _left = _context2.sent;
                _context2.next = 43;
                return this.evaluateNode(node.right);

              case 43:
                _right = _context2.sent;
                leftValue = _left.value, rightValue = _right.value;
                bothTypesAddress = function bothTypesAddress(left, right) {
                  return (// isAddress is true if type is address or bytes with size less than 20
                    _types.default.isAddress(left.type) && _types.default.isAddress(right.type)
                  );
                }, bothTypesBytes = function bothTypesBytes(left, right) {
                  return _types.default.types.bytes.isType(left.type) && _types.default.types.bytes.isType(right.type);
                };
                _context2.t1 = (bothTypesAddress(_left, _right) || bothTypesBytes(_left, _right) ? (leftValue = _ethers.BigNumber.from(leftValue), rightValue = _ethers.BigNumber.from(rightValue)) : (!_types.default.isInteger(_left.type) || !_types.default.isInteger(_right.type)) && this.panic("Cannot evaluate binary expression \"".concat(node.operator, "\" for non-integer or fixed-size bytes types \"").concat(_left.type, "\" and \"").concat(_right.type, "\"")), node.operator);
                _context2.next = _context2.t1 === "GREATER" ? 49 : _context2.t1 === "GREATER_EQUAL" ? 50 : _context2.t1 === "LESS" ? 51 : _context2.t1 === "LESS_EQUAL" ? 52 : _context2.t1 === "EQUAL_EQUAL" ? 53 : _context2.t1 === "BANG_EQUAL" ? 54 : 55;
                break;

              case 49:
                return _context2.abrupt("return", new TypedValue("bool", leftValue.gt(rightValue)));

              case 50:
                return _context2.abrupt("return", new TypedValue("bool", leftValue.gte(rightValue)));

              case 51:
                return _context2.abrupt("return", new TypedValue("bool", leftValue.lt(rightValue)));

              case 52:
                return _context2.abrupt("return", new TypedValue("bool", leftValue.lte(rightValue)));

              case 53:
                return _context2.abrupt("return", new TypedValue("bool", leftValue.eq(rightValue)));

              case 54:
                return _context2.abrupt("return", new TypedValue("bool", !leftValue.eq(rightValue)));

              case 55:
                if (!("TernaryExpression" === node.type)) {
                  _context2.next = 64;
                  break;
                }

                _context2.next = 58;
                return this.evaluateNode(node.predicate);

              case 58:
                if (!_context2.sent.value) {
                  _context2.next = 62;
                  break;
                }

                _context2.t2 = this.evaluateNode(node.left);
                _context2.next = 63;
                break;

              case 62:
                _context2.t2 = this.evaluateNode(node.right);

              case 63:
                return _context2.abrupt("return", _context2.t2);

              case 64:
                if (!("DefaultExpression" === node.type)) {
                  _context2.next = 69;
                  break;
                }

                _context2.next = 67;
                return this.evaluateNode(node.left);

              case 67:
                _left2 = _context2.sent;
                return _context2.abrupt("return", (leftFalsey = _types.default.isInteger(_left2.type) ? _left2.value.isZero() : "address" === _left2.type || _left2.type.startsWith("bytes") ? /^0x[0]*$/.test(_left2.value) : !_left2.value, leftFalsey ? this.evaluateNode(node.right) : _left2));

              case 69:
                if (!("CallExpression" === node.type)) {
                  _context2.next = 94;
                  break;
                }

                if (!("Identifier" === node.target.type && "self" === node.target.value)) {
                  _context2.next = 74;
                  break;
                }

                _context2.t3 = this.to;
                _context2.next = 77;
                break;

              case 74:
                _context2.next = 76;
                return this.evaluateNode(node.target);

              case 76:
                _context2.t3 = _context2.sent;

              case 77:
                target = _context2.t3;
                "bytes20" !== target.type && "address" !== target.type ? this.panic("Target of call expression was not an address") : !_ethers.ethers.utils.isAddress(target.value) && this.panic("Invalid address \"".concat(this.value, "\""));
                _context2.next = 81;
                return this.evaluateNodes(node.inputs);

              case 81:
                inputs = _context2.sent;
                outputs = node.outputs;
                selectedReturnValueIndex = outputs.findIndex(function (output) {
                  return output.selected;
                });
                -1 === selectedReturnValueIndex && this.panic("No selected return value for function call \"".concat(node.callee, "\""));
                returnType = outputs[selectedReturnValueIndex].type;
                abi = [{
                  name: node.callee,
                  type: "function",
                  inputs: inputs.map(function (_ref2) {
                    var type = _ref2.type;
                    return {
                      type: type
                    };
                  }),
                  outputs: outputs.map(function (_ref3) {
                    var type = _ref3.type;
                    return {
                      type: type
                    };
                  }),
                  stateMutability: "view"
                }];
                ethersInterface = new _ethers.ethers.utils.Interface(abi);
                txData = ethersInterface.encodeFunctionData(node.callee, inputs.map(function (input) {
                  return input.value.toString();
                }));
                _context2.next = 91;
                return this.provider.call({
                  to: target.value,
                  data: txData
                });

              case 91:
                data = _context2.sent;
                decodeData = ethersInterface.decodeFunctionResult(node.callee, data);
                return _context2.abrupt("return", new TypedValue(returnType, decodeData[selectedReturnValueIndex]));

              case 94:
                if (!("HelperFunction" === node.type)) {
                  _context2.next = 104;
                  break;
                }

                helperName = node.name;
                this.helpers.exists(helperName) || this.panic("".concat(helperName, " helper function is not defined"));
                _context2.next = 99;
                return this.evaluateNodes(node.inputs);

              case 99:
                _inputs = _context2.sent;
                _context2.next = 102;
                return this.helpers.execute(helperName, _inputs, {
                  provider: this.provider,
                  evaluator: this
                });

              case 102:
                result = _context2.sent;
                return _context2.abrupt("return", new TypedValue(result.type, result.value));

              case 104:
                if (!("PropertyAccessExpression" === node.type && "msg" === node.target.value)) {
                  _context2.next = 112;
                  break;
                }

                if (!("value" === node.property)) {
                  _context2.next = 107;
                  break;
                }

                return _context2.abrupt("return", this.value);

              case 107:
                if (!("sender" === node.property)) {
                  _context2.next = 109;
                  break;
                }

                return _context2.abrupt("return", this.from);

              case 109:
                if (!("data" === node.property)) {
                  _context2.next = 111;
                  break;
                }

                return _context2.abrupt("return", this.data);

              case 111:
                this.panic("Expecting value, sender or data property for msg identifier but got: ".concat(node.property));

              case 112:
                if (!("Identifier" === node.type)) {
                  _context2.next = 118;
                  break;
                }

                if (!("self" === node.value)) {
                  _context2.next = 115;
                  break;
                }

                return _context2.abrupt("return", this.to);

              case 115:
                this.bindings.hasOwnProperty(node.value) || this.panic("Undefined binding \"".concat(node.value, "\""));
                binding = this.bindings[node.value];
                return _context2.abrupt("return", new TypedValue(binding.type, binding.value));

              case 118:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function evaluateNode(_x2) {
        return _evaluateNode.apply(this, arguments);
      }

      return evaluateNode;
    }()
    /**
    * Evaluate the entire AST.
    *
    * @return {string}
    */

  }, {
    key: "evaluate",
    value: function () {
      var _evaluate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.evaluateNodes(this.ast.body).then(function (evaluatedNodes) {
                  return evaluatedNodes.join("");
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function evaluate() {
        return _evaluate.apply(this, arguments);
      }

      return evaluate;
    }()
    /**
    * Report an error and abort evaluation.
    *
    * @param  {string} msg
    */

  }, {
    key: "panic",
    value: function panic(msg) {
      throw new Error("Error: ".concat(msg));
    }
  }]);

  return Evaluator;
}();
/**
* Evaluates an AST
*
* @memberof radspec/evaluator
* @param {radspec/parser/AST} ast The AST to evaluate
* @param {radspec/Bindings} bindings An object of bindings and their values
* @param {?Object} options An options object
* @param {?Object} options.availablehelpers Available helpers
* @param {?ethers.providers.Provider} options.provider EIP 1193 provider
* @param {?string} options.to The destination address for this expression's transaction
* @return {string}
*/


exports.Evaluator = Evaluator;

function evaluate(ast, bindings, options) {
  return new Evaluator(ast, bindings, options).evaluate();
}